import { useLocation } from 'react-router-dom'

import { isModuleEnabled } from '@/config/modules'
import { useUser } from '@/contexts/UserContext'

import {
  TTemplateBreadcrumbProps,
  TTemplateBreadcrumbStructure,
  TTemplateSidebarProps,
} from './types'

export const useBreadcrumbProps = (): TTemplateBreadcrumbProps => {
  const location = useLocation()
  const page = location.pathname
  const pagePath = page.split('/').filter(item => item !== '')

  const breadcrumbStructure: TTemplateBreadcrumbStructure = {}

  if (isModuleEnabled('dashboard')) {
    breadcrumbStructure.dashboard = {
      info: { label: 'Painéis', href: '/dashboard' },
    }
  }

  if (isModuleEnabled('processamento')) {
    breadcrumbStructure.processamento = {
      info: { label: 'Processamento', href: '/processamento' },
      children: {
        detalhes: {
          info: { label: 'Detalhes do processamento', href: '/detalhes' },
        },
      },
    }
  }

  if (isModuleEnabled('envios')) {
    breadcrumbStructure.envios = {
      info: { label: 'Envios', href: '/envios' },
    }
  }

  if (isModuleEnabled('predicoes')) {
    breadcrumbStructure.predicoes = {
      info: { label: 'Predições', href: '/predicoes' },
      children: {
        resultado: {
          info: { label: 'Resultado', href: '/resultado' },
        },
      },
    }
  }

  if (isModuleEnabled('usuarios')) {
    breadcrumbStructure.usuarios = {
      info: { label: 'Usuários', href: '/usuarios' },
      children: {
        editar: {
          info: { label: 'Editar usuário', href: '/editar' },
        },
      },
    }
  }

  const breadcrumbItems = []
  let current: TTemplateBreadcrumbStructure = breadcrumbStructure

  for (const segment of pagePath) {
    const node = current[segment]
    if (!node) break
    breadcrumbItems.push(node.info)
    current = node.children ?? {}
  }

  return { items: breadcrumbItems }
}

export const useSidebarItems = () => {
  const { userProfile, isLoading } = useUser()

  if (isLoading) {
    return { linkItems: [] } as TTemplateSidebarProps
  }

  const defaultItems = [
    {
      module: 'dashboard',
      name: 'Painéis',
      icon: 'house-chimney',
      to: '/dashboard',
    },
    {
      module: 'processamento',
      name: 'Processamento',
      icon: 'cogs',
      to: '/processamento',
    },
    {
      module: 'predicoes',
      name: 'Predições',
      icon: 'folder-open',
      to: '/predicoes',
    },
    { module: 'envios', name: 'Envios', icon: 'upload', to: '/envios' },
  ]

  const adminItems = [
    { module: 'usuarios', name: 'Usuários', icon: 'users', to: '/usuarios' },
  ]

  const filteredDefault = defaultItems
    .filter(item => isModuleEnabled(item.module))
    .map(({ module, ...rest }) => rest)

  const filteredAdmin =
    userProfile === 'Admin'
      ? adminItems
          .filter(item => isModuleEnabled(item.module))
          .map(({ module, ...rest }) => rest)
      : []

  return {
    linkItems: [...filteredDefault, ...filteredAdmin],
  } as TTemplateSidebarProps
}
